export const getAbTestValueByName = (name) => {
  return (
    (window.ab_tests &&
      window.ab_tests[name]) ||
    'control'
  );
};
